/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'M8 6.1C8 5 9 4 10.1 4h5.7l.2.2V18c0 1.2-1 2.1-2.1 2.1H8.2a.2.2 0 0 1-.2-.2V6ZM8.2 22h7.6c1.2 0 2.2-1 2.2-2.2V4.2C18 3 17 2 15.8 2H8.2C7 2 6 3 6 4.2v15.6C6 21 7 22 8.2 22Zm3.8-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  DEV ? 'SmartphoneIcon' : '',
  '',
  false,
);
